import { Box, styled, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { IconToggle } from 'components/iconToggle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tree } from 'stores';
import { TreeContext } from 'views';
import { observer } from 'mobx-react';
import { Icon } from 'components/icon';


export interface IChartToolbarProps {
  chartType?: "time" | "attempts" | "status";
}

export const ChartToolbar = observer((props: IChartToolbarProps): JSX.Element => {
  const { t }      = useTranslation();
  const tree: Tree = React.useContext(TreeContext);
  const { chartType } = props;

  if(chartType == undefined) return null;

  return (
    <ChartToolbarContainer justifyContent={chartType === "time" ? "space-between" : "flex-end"}>
      {chartType === "time" && 
        <ToggleButtonGroup
          exclusive
          value    = {tree.time_scale}
          onChange = {(e, newScale) => {
            newScale && tree.setTimeScale(newScale);
          }}
        >
          <Tooltip placement='bottom' title={t("minute_plural")}>
            <ToolbarToggle selected={tree.time_scale === "m"} size="small" value="m">m</ToolbarToggle>
          </Tooltip>
          <Tooltip placement='bottom' title={t("hour_plural")}>
            <ToolbarToggle selected={tree.time_scale === "h"} size="small" value="h">h</ToolbarToggle>
          </Tooltip>
          <Tooltip placement='bottom' title={t("day_plural")}>
            <ToolbarToggle selected={tree.time_scale === "d"} size="small" value="d">d</ToolbarToggle>
          </Tooltip>
        </ToggleButtonGroup>
      }
      <IconToggle 
        iconOn         = {<Icon size='size-18' iconId='view'/>}
        iconOff        = {<Icon size='size-18' iconId='view-off' />}
        selected       = {tree.show_empty_chart}
        onChange       = {tree.toggleShowEmptyChart}
        tooltipIconOff = {t("show_empty")}
        tooltipIconOn  = {t("hide_empty_data")}
      />
    </ChartToolbarContainer>
  );
});

const ChartToolbarContainer = styled(Box)`
  position:        absolute;
  right:           53px;
  top:             50px;
  z-index:         20;
  align-items:     center;
  display:         flex;
  width:           120px;
`;
const ToolbarToggle = styled(ToggleButton)<{selected: boolean}>`
  height:      34px;
  line-height: 0px;
  font-weight: ${(p) => p.selected ? 500 : 300};
`;